/**
 * Tenants where DLP configure notifications must stay hidden.
 * Match on `user.primaryDomain` (lowercased).
 */
const DLP_NOTIFICATIONS_EXCLUDED_PRIMARY_DOMAINS = new Set([
  'successacademies.org',
  'tjx.com',
  'hall-woodhouse.co.uk',
])

export const isDlpConfigureNotificationsEnabledForPrimaryDomain = (
  primaryDomain: string | undefined,
): boolean =>
  !DLP_NOTIFICATIONS_EXCLUDED_PRIMARY_DOMAINS.has(
    (primaryDomain ?? '').toLowerCase(),
  )
